export const newspaperImg = "https://www.svgrepo.com/show/260121/newspaper-news.svg";
export const radioImg = "https://www.svgrepo.com/show/266362/play-pause.svg";
export const tvImg = "https://www.svgrepo.com/show/260137/television.svg";
export const blogImg = "https://www.svgrepo.com/show/343850/blog-seo-optimization-search.svg";
export const magazineImg = "https://www.svgrepo.com/show/181756/open-book-book.svg"
export const linkedInImg = "https://www.svgrepo.com/show/448234/linkedin.svg"
export const webImg = "https://www.svgrepo.com/show/415803/website-ui-web.svg"